import React, { useState } from "react"
import NextImg from "@/common/components/NextImg"
import styled from "styled-components"
import person from "@/common/assets/image/moneyFortune/person.webp"
import firstFloor from "@/common/assets/image/moneyFortune/first-floor.webp"
import building from "@/common/assets/image/moneyFortune/second-floor/building.webp"
import BGOthers from "./BGOthers"
import Title from "@/containers/MoneyFortune/View/decorate/Title"
import StartButton from "./StartButton"
import LOGO from "@/common/assets/image/moneyFortune/BlueLOGO.svg"

export default function Home({ page, setPage }) {
  const [homeAnimation, SetHomeAnimation] = useState(false)

  const start = () => {
    setTimeout(() => setPage(2), 3000)

    SetHomeAnimation(true)
  }

  return (
    <Wrapper className={homeAnimation === true && "active"}>
      <BG>
        <BGFirstWrapper className="BGFirst">
          <NextImg src={firstFloor} />
        </BGFirstWrapper>
        <BGBuildingWrapper className="BGBuilding">
          <NextImg src={building} />
        </BGBuildingWrapper>
        <BGOthersWrapper className="BGOthers">
          <BGOthers />
        </BGOthersWrapper>
      </BG>
      <ContentWrapper>
        <TitleWrapper className="ContentTitle">
          <LogoWrapper>
            <LogoBox>
              <NextImg src={LOGO} />
            </LogoBox>
          </LogoWrapper>
          <Title
            title1="你投資"
            title2="賺錢的"
            title3="可能性"
            title4="是多少"
            desc="免費領取結果 NFT"
          />
        </TitleWrapper>
      </ContentWrapper>
      <Foreground className="Foreground">
        <PersonLight />
        <PersonWrapper>
          <Person>
            <NextImg src={person} />
          </Person>
        </PersonWrapper>
        <Floor />
        <FloorUnderground />
      </Foreground>
      <StartButtonWrapper className="ContentBtn">
        {/* <StartButton content="START" onClick={start} /> */}
        <StartButton content="開始測驗拿NFT" hover="START" onClick={start} />
      </StartButtonWrapper>
      <FilterBG />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
  @media (max-width: 768px) {
  }

  &.active {
    .BGFirst {
      transform: translate(0, -30vh);
    }
    .BGBuilding {
      transform: translate(0, -60vh);
    }
    .BGOthers {
      transform: translate(0, -80vh);
    }
    .ContentTitle {
      transform: translate(0, -80vh);
    }
    .ContentBtn {
      transform: translate(0, -30vh);
      opacity: 0;
    }
    .Foreground {
      transform: translate(0, -100vh);
    }
  }
`

const FilterBG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--vh);
  background-color: #000000;
  z-index: 3;
  opacity: 1;
  animation: startBG 2s ease forwards;
  @keyframes startBG {
    0% {
      opacity: 1;
      display: block;
    }
    99% {
      opacity: 0;
      display: block;
      width: 100%;
      height: 100vh;
    }
    100% {
      display: none;
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
`

const BGFirstWrapper = styled.div`
  width: 100%;
  position: absolute;
  will-change: transform;
  bottom: 0;
  left: 0;
  transition: all 3s;
  @media (max-width: 768px) {
    /* top: 0; */
  }
`
const BGBuildingWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  transition: all 3s;
  will-change: transform;
  left: 0;
`

const PersonWrapper = styled.div`
  width: 150px;
  position: relative;
  will-change: transform;
  z-index: 3;
  bottom: 30px;
  animation: StartPeople 1.5s ease forwards;

  @keyframes StartPeople {
    0% {
      scale: 2;
      transform: translate(0, 50%);
    }
  }

  @media (max-width: 1000px) {
    width: 100px;
  }
`
const Person = styled.div`
  width: 100%;
  position: relative;
`
const PersonLight = styled.div`
  background-color: rgb(255, 255, 255);
  position: absolute;
  filter: blur(120px);
  bottom: -30px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 500px;
  width: 50%;
  height: 200px;
  border-radius: 50%;
`
const BG = styled.div`
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  position: absolute;
  z-index: 0;
  @media (max-width: 768px) {
    /* min-width: 1600px; */
  }
`
const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  will-change: transform;

  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: startContent 3s ease forwards;

  @keyframes startContent {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
      transform: translate(0, -5%);
    }
  }

  @media (max-width: 768px) {
    /* z-index: 4; */
  }
`

const Floor = styled.div`
  width: 100%;
  height: 50px;
  background:
    linear-gradient(to top, rgb(0, 0, 0), rgba(0, 4, 38, 0.526)),
    linear-gradient(30deg, #ff0000, rgba(0, 0, 0, 0) 80%),
    linear-gradient(270deg, #00fbfffd, rgba(0, 0, 0, 0)),
    linear-gradient(to top, #000000fc, rgba(0, 0, 0, 1));
  position: absolute;
`
const FloorUnderground = styled.div`
  position: absolute;
  bottom: calc(-100vh);
  width: 100%;
  height: 100vh;
  background-color: #000;
`

const TitleWrapper = styled.div`
  margin-bottom: 150px;
  display: flex;
  width: 95%;
  max-width: 1000px;
  flex-direction: column;
  transition: all 3s;
  align-items: flex-end;
  position: relative;
  padding: 20px;
`

const LogoBox = styled.div`
  width: 100%;
  position: relative;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.7));
`

const LogoWrapper = styled.div`
  width: 250px;
  position: absolute;
  z-index: 3;
  top: -40px;
  left: 50%;
  transform: translate(-50%, 0);
  @media (max-width: 1000px) {
    top: -80px;
  }
`

const Foreground = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  transition: all 3s;
  align-items: end;
  z-index: 3;
`

const BGOthersWrapper = styled.div`
  transition: all 3s;
`
const StartButtonWrapper = styled.div`
  width: 400px;
  transition: all 3s;
  position: absolute;
  top: calc(50vh + 150px);
  z-index: 3;
  @media (max-width: 800px) {
    width: 300px;
    h1 {
      font-size: 20px;
    }
  }
`
